import * as THREE from 'three';

/** Capsule stand-in for a fighter, sitting on the floor at the given spot. */
export function createPlaceholderFighter({ color = 0xc2553f, radius = 0.32, height = 1.1 } = {}) {
  const mesh = new THREE.Mesh(
    new THREE.CapsuleGeometry(radius, height, 8, 20),
    new THREE.MeshStandardMaterial({ color, roughness: 0.6, metalness: 0.05 })
  );
  mesh.name = 'placeholder-fighter';
  mesh.castShadow = true;
  mesh.position.y = height / 2 + radius;
  return mesh;
}
